import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import QuotationMark from '@client/components/guestbookEntry/quotationMark/QuotationMark';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import ModalTrigger from '@client/components/modalTrigger/ModalTrigger';
import { removeInitialZero } from '@client/components/guestbookEntry/GuestbookEntryUtils';
import ReportConfirmation from '@client/components/guestbookEntry/reportConfirmation/ReportConfirmation';
import DeleteConfirmation from '@client/components/guestbookEntry/deleteConfirmation/DeleteConfirmation';
import styles from './guestbookEntry.scss';

function GuestbookEntry({
  className,
  comment,
  isMyFundraiser,
  isLoggedInAsAdmin,
  fundraiserId,
  deletePost,
  reportPost,
  hasBeenReported,
}) {
  const dateAndTimeString = getIn(comment, 'createdTime');
  const isReported = getIn(comment, 'reported');
  const showDeleteBtn = isMyFundraiser || isLoggedInAsAdmin;
  const [showReportBtn, setShowReportBtn] = useState(
    !showDeleteBtn && !isReported
  );
  const [showHasBeenReported, setShowHasBeenReported] = useState(
    !showDeleteBtn && isReported
  );

  const year = dateAndTimeString && dateAndTimeString.substring(0, 4);
  const month =
    dateAndTimeString && removeInitialZero(dateAndTimeString.substring(5, 7));
  const date =
    dateAndTimeString && removeInitialZero(dateAndTimeString.substring(8, 10));

  return (
    <div className={classNames(styles.guestbookEntry, className)}>
      <div className={styles.titleContainer}>
        <h4 className={styles.entryTitle}>{getIn(comment, 'title')}</h4>
        <QuotationMark />
      </div>
      <p className={styles.paragraph}>{getIn(comment, 'content')}</p>
      <div className={classNames(styles.paragraph, styles.entryBtnContainer)}>
        <span>
          {getIn(comment, 'authorName')} <br />
          {date && date}/{month && month} {year && year}
        </span>
        {showDeleteBtn && (
          <ModalTrigger
            TriggerElement={<button>{deletePost}</button>}
            ModalContent={
              <DeleteConfirmation
                className={styles.confirmationModalProp}
                fundraiserId={fundraiserId}
                commentId={getIn(comment, 'id')}
              />
            }
          />
        )}
        {showReportBtn && (
          <ModalTrigger
            TriggerElement={<button>{reportPost}</button>}
            ModalContent={
              <ReportConfirmation
                className={styles.confirmationModalProp}
                fundraiserId={fundraiserId}
                commentId={getIn(comment, 'id')}
                setShowHasBeenReported={setShowHasBeenReported}
                setShowReportBtn={setShowReportBtn}
              />
            }
          />
        )}
        {showHasBeenReported && hasBeenReported}
      </div>
    </div>
  );
}

GuestbookEntry.propTypes = {
  className: PropTypes.string,
  comment: PropTypes.object,
  fundraiserId: PropTypes.string,
  isMyFundraiser: PropTypes.bool,
  isLoggedInAsAdmin: PropTypes.bool,
  deletePost: PropTypes.string,
  reportPost: PropTypes.string,
  hasBeenReported: PropTypes.string,
};

export default GuestbookEntry;
